function activeSliderRangeFilter(div_section){
    //Get the current price search
    var search_array = window.location.search.split('&');
    var current_max_search = 0;
    var current_min_search = 0;
    search_array.forEach(function(search_option){
        if(search_option.indexOf('filter.v.price.gte') > -1){
            current_min_search = parseInt(search_option.slice(19));
        }
        if(search_option.indexOf('filter.v.price.lte') > -1){
            current_max_search = parseInt(search_option.slice(19));
        }
    });
    if(window.innerWidth > 1200){
        var filter_wrapper = $('.' + div_section + ' .filter-form .filter-group .filter-content .filter-price');
        var max_value = parseInt(filter_wrapper[0].dataset.max);
        var filter_slide = $('.' + div_section + ' .filter-form .filter-group .filter-content .filter-price .slider-range');
        var min_current_value = current_min_search > 0 ? current_min_search : 0;
        var max_current_value = current_max_search > 0 ? current_max_search : max_value;
    
        filter_slide.slider({
            range: true,
            min: 0,
            max: max_value,
            values: [ min_current_value, max_current_value ],
            slide: function( event, ui ) {
                $('#amount-filter-min' ).val( ui.values[ 0 ]);
                $('#amount-filter-max' ).val( ui.values[ 1 ]);
            }
        });
        $( '#amount-filter-min' ).val(filter_slide.slider('values', 0));
        $( '#amount-filter-max' ).val(filter_slide.slider('values', 1));
    }
    else{
        var filter_wrapper = $('.' + div_section + ' .mobile-filter-form .filter-group .filter-content .filter-price');
        var max_value = parseInt(filter_wrapper[0].dataset.max);
        var filter_slide = $('.' + div_section + ' .mobile-filter-form .filter-group .filter-content .filter-price .slider-range');
    
        var min_current_value = current_min_search > 0 ? current_min_search : 0;
        var max_current_value = current_max_search > 0 ? current_max_search : max_value;
    
        filter_slide.slider({
            range: true,
            min: 0,
            max: max_value,
            values: [ min_current_value, max_current_value ],
            slide: function( event, ui ) {
                $('#amount-filter-mobile-min' ).val( ui.values[ 0 ]);
                $('#amount-filter-mobile-max' ).val( ui.values[ 1 ]);
            }
        });
        $( '#amount-filter-mobile-min' ).val(filter_slide.slider('values', 0));
        $( '#amount-filter-mobile-max' ).val(filter_slide.slider('values', 1));
    }
}

function updateCollectionFilter(div_section, html_new){
    document.querySelector(`.${div_section} .collection-filter-container`).innerHTML = html_new;
    activeSliderRangeFilter(div_section);
    var check_slide = $(`.${div_section}`).attr('data-slide');
    if(check_slide == 'true'){
        activeSlideFilterSection(div_section);
    }
}
function collectionFilterSectionToggle(div_section){
    var collection_handle = $(`.${div_section}`).attr('data-collection');
    //Grid-List button
    $('body').on('click', `.${div_section} .collection-filter-container .result-container .filter-sorting-liststyle .sorting-liststyle .list`, function() {
        $('.' + div_section + ' .collection-filter-container .result-container .products-container .result-wrapper-list').removeClass('hide');
        $('.' + div_section + ' .collection-filter-container .result-container .products-container .result-wrapper-grid').addClass('hide');
        $(this).addClass('button-active');
        $(`.${div_section} .collection-filter-container .result-container .filter-sorting-liststyle .sorting-liststyle .grid`).removeClass('button-active');
    });
    $('body').on('click', `.${div_section} .collection-filter-container .result-container .filter-sorting-liststyle .sorting-liststyle .grid`, function() {
        $('.' + div_section + ' .collection-filter-container .result-container .products-container .result-wrapper-list').addClass('hide');
        $('.' + div_section + ' .collection-filter-container .result-container .products-container .result-wrapper-grid').removeClass('hide');
        $(this).addClass('button-active');
        $(`.${div_section} .collection-filter-container .result-container .filter-sorting-liststyle .sorting-liststyle .list`).removeClass('button-active');
    });
    //Sort Button
    //Title
    $('body').on('click', `.${div_section} .collection-filter-container .result-container .filter-sorting-liststyle .sorting-liststyle .sort-wrapper`, function() {
        $(this).children('ul').toggleClass('active');
        $(this).children('i').toggleClass('icon-active');
    });
    //Sort options
    $('body').on('click', `.${div_section} .collection-filter-container .sort-wrapper .list-option .list-item`, function() {
        //This sort value
        $(this).siblings('li').removeClass('active');
        $(this).addClass('active');
        //Sort title
        var sort_text = $(this).children('span').text();
        $(this).parent().siblings('.sort-title').text(sort_text);
        //Loading class
        $(`.${div_section} .loading-wrapper`).addClass('loading-active');
        //Change the data with ajax
        var form_div = $(`.${div_section} .filter-container .filter-form`)[0];
        var form_data = new URLSearchParams(new FormData(form_div)).toString();
        var sort_key = $(this).attr('data-value');
        fetch(window.Shopify.routes.root + `collections/${collection_handle}?sort_by=${sort_key}&${form_data}`)
        .then(response => response.text())
        .then(data => {
            let html_div = document.createElement('div');
            html_div.innerHTML = data;
            //Update link and sort variable
            history.replaceState(null, null, `?sort_by=${sort_key}&${form_data}`);
            document.querySelector(`.${div_section}`).setAttribute('data-sort',sort_key);
            //List of products
            let html_dom = html_div.querySelector('.' + div_section + ' .collection-filter-container').innerHTML;
            updateCollectionFilter(div_section, html_dom);
        })
        .catch(error => console.log('Error:',error))
        .finally(() => $(`.${div_section} .loading-wrapper`).removeClass('loading-active'));
    });

    //Filter
    //Filter Conditional Header Toggle
    $('body').on('click', `.${div_section} .filter-group .filter-title-wrapper`, function() {
        $(this).siblings('.filter-content').slideToggle('fast');
        $(this).children('.plus').toggleClass('hide');
        $(this).children('.minus').toggleClass('hide');
    });
    //Filter hidden
    $('body').on('click', `.${div_section} .filter-group .filter-hidden .filter-hidden-header`, function() {
        $(this).addClass('hide');
        $(this).siblings('.filter-hidden-header-after').removeClass('hide');
        $(this).siblings('.filter-hidden-content').slideDown('fast');
    });
    $('body').on('click', `.${div_section} .filter-group .filter-hidden .filter-hidden-header-after`, function() {
        $(this).addClass('hide');
        $(this).siblings('.filter-hidden-header').removeClass('hide');
        $(this).siblings('.filter-hidden-content').slideUp('fast');
    });
    //Filter load with ajax
    $('body').on('change', `.${div_section} .filter-container .filter-group .filter-content input`, function() {
        $(`.${div_section} .loading-wrapper`).addClass('loading-active');
        var form_div = $(`.${div_section} .filter-container .filter-form`)[0];
        var form_data = new URLSearchParams(new FormData(form_div)).toString();
        var data_sort = $(`.${div_section}`).attr('data-sort');
        fetch(window.Shopify.routes.root + `collections/${collection_handle}?sort_by=${data_sort}&${form_data}`)
        .then(response => response.text())
        .then(data => {
            let html_cont = document.createElement('div');
            html_cont.innerHTML = data;
            history.replaceState(null, null, `?sort_by=${data_sort}&${form_data}`);
            let html_products = html_cont.querySelector(`.${div_section} .collection-filter-container`).innerHTML;
            updateCollectionFilter(div_section, html_products);
        })
        .catch(error => console.log('Error:',error))
        .finally(() => $(`.${div_section} .loading-wrapper`).removeClass('loading-active'));
    });
    //Clear filter with ajax
    $('body').on('click', `.${div_section} .result-container .filter-sorting-liststyle .actived-filter .remove-filter`, function(e) {
        e.preventDefault();
        $(`.${div_section} .loading-wrapper`).addClass('loading-active');
        var url_remove = $(this).attr('href');
        fetch(url_remove)
        .then(response => response.text())
        .then(data => {
            let html_cont = document.createElement('div');
            html_cont.innerHTML = data;
            //Update link
            history.replaceState(null, null, url_remove);
            let html_products = html_cont.querySelector(`.${div_section} .collection-filter-container`).innerHTML;
            updateCollectionFilter(div_section, html_products);
        })
        .catch(error => console.log('Error:',error))
        .finally(() => $(`.${div_section} .loading-wrapper`).removeClass('loading-active'));
    });

    //Filter button mobile
    $('body').on('click', `.${div_section} .result-container .filter-sorting-liststyle .sorting-liststyle .filter-mobile-button`, function() {
        $('.' + div_section + ' .mobile-filter-container').addClass('filter-active');
    });
    $('body').on('click', `.${div_section} .result-container .mobile-filter-container .mobile-filter-form-wrapper .mobile-filter-header .close`, function() {
        $('.' + div_section + ' .mobile-filter-container').removeClass('filter-active');
    });
    //Filter load with AJAX - mobile
    $('body').on('change', `.${div_section} .result-container .mobile-filter-container .mobile-filter-form .filter-group .filter-content input`, function() {
        $(`.${div_section} .mobile-filter-container`).removeClass('filter-active');
        $(`.${div_section} .loading-wrapper`).addClass('loading-active');
        var form_div = $(`.${div_section} .result-container .mobile-filter-container .mobile-filter-form-wrapper`)[0];
        var form_data = new URLSearchParams(new FormData(form_div)).toString();
        var data_sort = $(`.${div_section}`).attr('data-sort');
        fetch(window.Shopify.routes.root + `collections/${collection_handle}?sort_by=${data_sort}&${form_data}`)
        .then(response => response.text())
        .then(data => {
            let html_cont = document.createElement('div');
            html_cont.innerHTML = data;
            history.replaceState(null, null, `?sort_by=${data_sort}&${form_data}`);
            let html_products = html_cont.querySelector(`.${div_section} .collection-filter-container`).innerHTML;
            updateCollectionFilter(div_section, html_products);
        })
        .catch(error => console.log('Error:',error))
        .finally(() => $(`.${div_section} .loading-wrapper`).removeClass('loading-active'));
    });
}